<perfect-scrollbar class="pb-4">
    <div class="sidebar-header">
        <a class="sidebar-brand text-center" routerLink='/'><img height="120" [src]="'./assets/img/logo-light-v.png'"/></a>
        <a class="sidebar-brand-mini" routerLink='/'>W</a>
    </div>
    <navigation></navigation>
</perfect-scrollbar>
